/**
 * PDF guide metadata for the post-subscription download dialog.
 * Download URLs should point to Firebase Storage (or any public file URL).
 *
 * To get Firebase Storage URLs:
 * 1. Upload PDFs in Firebase Console → Storage
 * 2. Click a file → Get download URL
 * 3. Paste the URL here (ensure storage rules allow read access)
 */
export interface PdfGuide {
  id: string;
  title: string;
  description: string;
  /** Public download URL (e.g. from Firebase Storage) */
  downloadUrl: string;
  /** Filename for the downloaded file */
  filename: string;
}

export const PDF_GUIDES: PdfGuide[] = [
  {
    id: 'mht',
    title: 'Your Top Questions About HRT—Answered by Experts',
    description: 'These facts and expert insights will help you decide what’s right for you (and advocate for it!).',
    downloadUrl: 'https://firebasestorage.googleapis.com/v0/b/mr-website-fb6db.firebasestorage.app/o/downloads%2FMeghan-Rabbitt-HRT-Guide.pdf?alt=media&token=2b4f259e-8298-4cc9-8fd4-9a06f8d967ea',
    filename: 'meghan_rabbitt_hrt_guide.pdf',
  },
  {
    id: 'breast-health',
    title: 'What Too Many of Us Don’t Know About Breast Health',
    description: 'These are the facts practitioners want us to know about lumps, dense breasts, cancer prevention, and more.',
    downloadUrl: 'https://firebasestorage.googleapis.com/v0/b/mr-website-fb6db.firebasestorage.app/o/downloads%2FMeghan-Rabbitt-Breast-Health.pdf?alt=media&token=f634b4bb-723c-48d2-b227-9df0cba79595',
    filename: 'meghan_rabbitt_breast_health_guide.pdf',
  },
  // {
  //   id: 'guide-3',
  //   title: 'Nutrition Foundations',
  //   description: 'Simple, sustainable nutrition principles to fuel your body and feel your best.',
  //   downloadUrl: '', // Replace with Firebase Storage URL
  //   filename: 'nutrition-foundations.pdf',
  // },
];
